import request from "@/utils/request";

export function index(params) {
  return request({
    url: "/icons",
    method: "get",
    params
  });
}
export function update(id, data) {
  return request({
    url: "/icons/" + id,
    method: "put",
    data
  });
}
export function show(id) {
  return request({
    url: "/icons/" + id,
    method: "get"
  });
}
export function store(data) {
  return request({
    url: "/icons",
    method: "post",
    data
  });
}
export function destroy(id) {
  return request({
    url: "/icons/" + id,
    method: "delete"
  });
}
